import { CssBaseline, CssFonts } from '@dbi-tools/ui-kit';
import favicon from '@quiz-frontend/markup/images/favicon.ico';
import * as Sentry from '@sentry/node';
import App from 'next/app';
import Head from 'next/head';
import React, { Fragment } from 'react';
import { Provider } from 'react-redux';
import { Store } from 'redux';
import * as UAParser from 'ua-parser-js';

import AppWrapper from '../components/app-wrapper';
import { NODE_ENV, SENTRY_DSN } from '../service/variables';
import { cleanPageError, setIsMobile } from '../store/app/actions';

Sentry.init({
  dsn: SENTRY_DSN,
  environment: NODE_ENV,
  enabled: !!SENTRY_DSN,
});

class MyApp extends App<{ store: Store }> {
  static async getInitialProps({ Component, ctx }) {
    ctx.store.dispatch(cleanPageError());
    const userAgent = UAParser(ctx.req ? ctx.req.headers['user-agent'] : navigator.userAgent);
    ctx.store.dispatch(setIsMobile(userAgent.device.type === UAParser.DEVICE.MOBILE));
    const pageProps = Component.getInitialProps ? await Component.getInitialProps(ctx) : {};
    return { pageProps };
  }

  render() {
    const { Component, pageProps, store } = this.props;

    // Workaround for https://github.com/zeit/next.js/issues/8592
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const { err } = this.props as any;
    const modifiedPageProps = { ...pageProps, err };

    return (
      <Fragment>
        <Head>
          <meta name="viewport" content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no" />
          <link rel="icon" type="image/x-icon" href={favicon.src} />
        </Head>
        <Provider store={store}>
          <AppWrapper>
            <Fragment>
              <CssBaseline />
              <CssFonts />
              <Component {...modifiedPageProps} />
            </Fragment>
          </AppWrapper>
        </Provider>
      </Fragment>
    );
  }
}

export default MyApp;
